import CommitDiffsFileOptionsDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/options_menu/commit_diffs_file_options_dropdown.vue?vue3';
import { createOptionsMenuAdapter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/adapters/options_menu.js?vue3';
import { commitDiffDiscussionsStore } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/stores/instances/commit_discussions.js?vue3';

export const commitDiffsOptionsMenuAdapter = createOptionsMenuAdapter(
  CommitDiffsFileOptionsDropdown,
  commitDiffDiscussionsStore,
);
